import React, { useState } from 'react';
import { InputGroup, Button, InputBase } from '../../../../../../../common/@roma/src';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { TagEditContentProps } from '../tagComponentPropTypes';

const TagRenameField: React.FC<TagEditContentProps> = ({ tag, closePopups, updateTag }) => {
    const translate = useTranslator('popup', 'tags.edit');
    if (!tag) return null;

    const [name, setName] = useState<string>(tag.name);

    const handleNameChange = () => {
        updateTag({ name });
        closePopups();
    };

    return (
        <InputGroup
            size="sm"
            aria-label="Edit tag name"
            onChange={setName}
            trailingAddon={
                <Button color="primary" size="sm" onClick={handleNameChange} isDisabled={!name}>
                    {translate('rename')}
                </Button>
            }
        >
            <InputBase type="text" placeholder="Edit name" value={name} />
        </InputGroup>
    );
};

export default TagRenameField;
